import './styles.scss';
import { getTranslationOptions } from 'ducks/i18n/selectors';
import React from 'react';
import { connect } from 'react-redux';
import { AnyTypeToFix } from 'types/anytype';
import { FlagsSelect } from '@components/index';
import { setTranslationLocale } from 'ducks/i18n/actions';
import { LogoIconGreen } from '@components/commons/logo-icon';

function getIsWebview() {
  return (
    (typeof window !== 'undefined' && (window as any).__IS_EXPO_WEBVIEW__) ??
    false
  );
}
const LoginPageLayout: React.FC<{
  options: ReturnType<typeof getTranslationOptions>;
  setTranslationLocale: typeof setTranslationLocale;
  children: React.ReactNode;
}> = (props) => {
  const { options, setTranslationLocale } = props;

  const isWebview = React.useMemo(() => getIsWebview(), []);

  return (
    <div className="login__main__container">
      <div className="bg-gray-800 text-white py-3 px-4 text-center fixed left-0 top-0 right-0 z-40">
        {/* FlagsSelect is not supported in webview so we hide it because issues with D-PAD */}
        {!isWebview && (
          <FlagsSelect
            options={options}
            onSelect={({ country }: { country: string }) =>
              setTranslationLocale(country)
            }
            className="language-right-position auth-language"
          />
        )}
      </div>
      <div className="min-h-screen bg-dark flex flex-col justify-center sm:py-12">
        <div className="p-10 xs:p-0 mx-auto md:w-full md:max-w-md">
          <h1 className="font-bold text-center text-2xl mb-5">
            <div className="mx-auto logo-container">
              <LogoIconGreen />
            </div>
          </h1>
          <div className="bg-dark shadow w-full rounded-lg divide-y divide-gray-200">
            {props.children}
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: AnyTypeToFix) => ({
  options: getTranslationOptions(state),
  store: { getState: () => state }
});

const mapDispatchToProps = {
  setTranslationLocale
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginPageLayout);
